import { CircularProgress, Tooltip } from "@material-ui/core";
import { RowActionButton, RowActionLink, RowActionsContainer } from "./styles";
import { BiEdit, BiTrash } from "react-icons/bi";
import { AiOutlineQrcode } from "react-icons/ai";
import swal from "sweetalert";
import { useState } from "react";
import { producaov2 } from "../../../../../services/apis";
import { toast } from "react-toastify";
import QrCodeModal from "./QrCodeModal";

export default function SurveyRowActions({ surveyID, slug, onDelete }) {
  const [surveyLink, setSurveyLink] = useState("");
  const [loadingDelete, setLoadingDelete] = useState(false);

  const handleDelete = async () => {
    const response = await swal({
      title: "Deseja excluir essa pesquisa?",
      text: "Essa ação é irreversível",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancelar", "Remover"],
    });

    if (response) {
      setLoadingDelete(true);

      try {
        await producaov2.delete(`/admin/surveys/${surveyID}`, {
          headers: {
            access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
          },
        });

        toast.success("Pesquisa excluida com sucesso");
        onDelete();
      } catch (error) {
        toast.error(
          `Houve um erro ao excluir a pesquisa: ${
            error?.response?.data?.message || error?.message
          }`
        );
      } finally {
        setLoadingDelete(false);
      }
    }
  };

  const handleGenerateSurveyQRCode = () => {
    setSurveyLink(`https://voitto.com.br/pesquisa/${slug}`);
  };

  return (
    <>
      <RowActionsContainer>
        <Tooltip title="Editar a pesquisa">
          <RowActionLink href={`/admin/pesquisa/${surveyID}`}>
            <BiEdit />
          </RowActionLink>
        </Tooltip>
        <Tooltip title="Baixar QR Code">
          <RowActionButton onClick={handleGenerateSurveyQRCode}>
            <AiOutlineQrcode />
          </RowActionButton>
        </Tooltip>
        <Tooltip title="Excluir a pesquisa. Essa ação irreversível">
          <RowActionButton disabled={loadingDelete} onClick={handleDelete}>
            {loadingDelete ? (
              <CircularProgress size={14} />
            ) : (
              <BiTrash color="#ff0000" />
            )}
          </RowActionButton>
        </Tooltip>
      </RowActionsContainer>
      {surveyLink && (
        <QrCodeModal
          surveyID={surveyID}
          value={surveyLink}
          onClose={() => setSurveyLink("")}
        />
      )}
    </>
  );
}
